import { asset } from "../../lib/api";
import { FRAME_STYLE } from "../../lib/art";

export const Framed = ({ src, frame = "none", className = "", testid, onClick }) => {
  const f = FRAME_STYLE[frame] || FRAME_STYLE.none;
  return (
    <div data-testid={testid} onClick={onClick} className={`shadow-lg ${frame === "none" ? "rounded-2xl overflow-hidden" : "rounded-md"} ${className}`} style={{ padding: f.pad, background: f.bg }}>
      <div className="bg-white" style={f.inner ? { padding: 4, background: f.inner } : { padding: frame === "none" ? 0 : 6 }}>
        <img src={asset(src)} alt="" draggable={false} className="w-full aspect-square object-cover bg-white block select-none" />
      </div>
    </div>
  );
};

export const FramePicker = ({ frames, value, onChange, full }) => (
  <div className="flex flex-wrap gap-2" data-testid="frame-picker">
    {frames.map((f) => {
      const locked = f.premium && !full;
      const s = FRAME_STYLE[f.key];
      return (
        <button key={f.key} type="button" data-testid={`frame-${f.key}`} disabled={locked} onClick={() => onChange(f.key)}
          className={`relative w-20 rounded-xl p-1.5 text-xs font-bold border-2 ${value === f.key ? "border-[#E2683C] bg-orange-50" : "border-stone-200 bg-white"} ${locked ? "opacity-40" : ""}`}>
          <span className="block h-10 rounded-md" style={{ background: f.key === "none" ? "#f5f5f4" : s.bg, padding: 6 }}><span className="block h-full bg-white rounded-sm" /></span>
          <span className="block mt-1">{f.name}{locked ? " 👑" : ""}</span>
        </button>
      );
    })}
  </div>
);
